import React from 'react'
import StyledText from '../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';
import styled from 'styled-components';
import { font, FontType, Theme } from '../../../utils/themes';

interface ProrationListing {
    prorationType: string;
}

const ProrationListing: React.FC<ProrationListing> = ({ prorationType }) => {

    const {theme} = useTheme();

    const ProrationMethod = [
      {
        month: 'January',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'February',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'March',
        percentage: '100',
        price: '650',
      },
      {
        month: 'April',
        percentage: '100',
        price: '650',
      },
      {
        month: 'May',
        percentage: '100',
        price: '650',
      },
      {
        month: 'June',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'July',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'August',
        percentage: '100',
        price: '550',
      },
      {
        month: 'September',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'October',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'November',
        percentage: '84.1634',
        price: '550',
      },
      {
        month: 'December',
        percentage: '84.1634',
        price: '550',
      }
    ];

  return (
    <div>
        {prorationType === 'monthly' ?
        <ProrationWrapper className='table-proration-method' theme={theme}>
            {ProrationMethod.map((method, index) => (
                <>
                <div key={index} className='proration-item d-flex align-items-center justify-content-between'>
                <StyledText
                    textColor={theme.CorporateTheme.colors.blueberry}
                >
                    {method?.month}:
                </StyledText>
                <PercentageBox theme={theme} font={font}>
                    {method?.percentage}
                    <span>
                    %
                    </span>
                </PercentageBox>
                <StyledText
                    textColor={theme.CorporateTheme.colors.headerColor}
                    fontFamily={font.lato}
                >
                    ${method?.price}
                </StyledText>
                </div>
                </>
            ))}
        </ProrationWrapper>
        : prorationType === 'quarterly' ?
            <div>
                Quarterly proration
            </div>
        :
        null
        }
    </div>
  )
}

export default ProrationListing

const ProrationWrapper = styled.div<{ theme: Theme }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(6, auto);
  grid-auto-flow: column;
  gap: 25px 0px;

    .proration-item{
      &:nth-child(-n+6) {
        border-right: 0.5px solid;
        padding-right: 20px;
        border-color: ${({theme}) => theme.CorporateTheme.colors.border};
      }
      &:nth-child(n+7) {
        padding-left: 20px;
      }
    }
`;

const PercentageBox = styled.div<{ theme: Theme, font: FontType }>`
  padding: 10px;
  border: 0.5px solid;
  border-color: ${({theme}) => theme.CreateFormTheme.colors.inputBorders};
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: ${({theme}) => theme.CorporateTheme.colors.headerColor};
  font-family: ${({font}) => font.lato};
  width: 122px;
  position: relative;
  span {
    padding: 10px 0px 10px 12px;
    border-left: 0.5px solid;
    border-color: ${({theme}) => theme.CreateFormTheme.colors.inputBorders};
    position: absolute;
    top: 0;
    right: 12px;
  }
`;